module.exports = __webpack_public_path__ + "img/marco-pro.931a2943.jpg";